



import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {}
})
export default class TestingPointPic extends ViewBase {
  @Prop({ default: null }) process!: any
  @Prop({ default: 0 }) time!: number
  lang: any = {}

  echartSource: any = []
  // 鼠标指到柱状图上的提示文字
  textArr: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  onStudentChange(value: any) {}

  drawLine() {
    // 基于准备好的dom，初始化echarts实例
    const myChart = echarts.init(this.$refs.myChart)
    const that = this
    const option = {
      legend: {},
      tooltip: {
        trigger: 'item' /*此处为item*/,
        axisPointer: {
          type: 'line'
        },
        formatter(params: any, trigger: any) {
          const index = params.value.index
          const textKey = params.dimensionNames[params.encode.y[0]]
          return `<div style="text-align:center"><div>${that.textArr[index][textKey].num}人,
          ${that.textArr[index][textKey].rate}%<br>${that.textArr[index][textKey].text}</div></div>`
        }
      },
      dataset: {
        dimensions: ['product', 'correct', 'error', 'empty'],
        source: that.echartSource
      },
      xAxis: {
        type: 'category',
        name: that.lang.xAxisText,
        nameLocation: 'center',
        nameTextStyle: { padding: 10 }
      },
      yAxis: [
        {
          type: 'value',
          name: that.lang.accuracyRate,
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: '{value}.00 %'
          }
        },
        // {
        //   type: 'value',
        //   name: that.lang.perNum,
        //   min: 0,
        //   max: 3,
        //   interval: .3,
        //   axisLabel: {
        //     formatter: '{value}'
        //   }
        // }
      ],
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
        {
          barGap: 0,
          name: that.lang.accuracyRate,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#33CC33'
            }
          }
        },
        {
          name: that.lang.errorRate,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#FF6600'
            }
          }
        },
        {
          name: that.lang.empty,
          type: 'bar',
          itemStyle: {
            normal: {
              color: '#A5A5A5'
            }
          }
        }
      ]
    }
    // 绘制图表
    myChart.setOption(option)
  }

  setSource() {
    const process = this.process
    const arr = []
    const textArr = []
    let index = 0
    for (const key of Object.keys(process)) {
      // 鼠标指上去的提示文字
      const textObj: any = {
        correct: {},
        error: {},
        empty: {}
      }
      // echarts绘制对象
      const obj: any = {}
      obj.product = process[key].k_name
      obj.correct = process[key].correct.rate
      obj.error = process[key].error.rate
      obj.empty = process[key].empty.rate
      obj.index = index++
      arr.push(obj)
      textObj.correct.text = process[key].correct.cid_name_list
      textObj.correct.rate = process[key].correct.rate
      textObj.correct.num = process[key].correct.num
      textObj.error.text = process[key].error.cid_name_list
      textObj.error.rate = process[key].error.rate
      textObj.error.num = process[key].error.num
      textObj.empty.text = process[key].empty.cid_name_list
      textObj.empty.rate = process[key].empty.rate
      textObj.empty.num = process[key].empty.num
      textArr.push(textObj)
    }
    this.textArr = textArr
    this.echartSource = arr
  }

  created() {
    this.lang = this.i18n.vStudy
    setTimeout(() => {
      this.setSource()
      this.drawLine()
    })
  }
  @Watch('time')
  watchTime() {
    this.setSource()
    this.drawLine()
  }
}
